import { render, staticRenderFns } from "./FormCategory.vue?vue&type=template&id=20c891dc&scoped=true"
import script from "./FormCategory.vue?vue&type=script&lang=js"
export * from "./FormCategory.vue?vue&type=script&lang=js"
import style0 from "./FormCategory.vue?vue&type=style&index=0&id=20c891dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c891dc",
  null
  
)

export default component.exports